import React from 'react';

function MaterialsDetails() {

    return (
        <div
            id="materials-details-page-content"
            className="content-block">

            <p className="content-block-text cover-page-centered cover-page-bu-title">
                Boston University College of Arts and Sciences
            </p>

            <p className="content-block-text cover-page-centered cover-page-machine-shop">
                Physics Department Machine Shop
            </p>

            <div className="bu-redline-footer" style={{ width: '80%', marginTop: '2rem' }}></div>

            <div 
                className="cover-page-split-details"
                style={{ marginTop: '1rem' }}>

                <p className="content-block-text">
                    Project N
                </p>
        
                <p className="content-block-text">
                    Client Name
                </p>
            
            </div>

            <p 
                className="content-block-text cover-page-centered"
                style={{ marginTop: '2rem', fontSize: '1.5em' }}>
                Materials
            </p>

            {/* <!-- table with employee #, workday, hours, overtime --> */}
            <div className="materials-table">

                <div
                    className="cover-page-split-details"
                    style={{ marginTop: '1rem' }}>

                    <div className="materials-details-grid">

                        {/* <!-- row 1 --> */}
                        <div className="materials-grid-1-1">Supplier</div>
                        <div className="materials-grid-1-2">Item</div>
                        <div className="materials-grid-1-3">Reported</div>
                        <div className="materials-grid-1-4">Cost</div>

                        {/* <!-- row 2 -- orange line --> */}
                        <div 
                            className="materials-grid-2-1" 
                            style={{ backgroundColor: 'orange', height: '0.25rem' }}>
                            &nbsp;
                        </div>
                        <div 
                            className="materials-grid-2-2" 
                            style={{ backgroundColor: 'orange', height: '0.25rem' }}>
                            &nbsp;
                        </div>
                        <div 
                            className="materials-grid-2-3" 
                            style={{ backgroundColor: 'orange', height: '0.25rem' }}>
                            &nbsp;
                        </div>
                        <div 
                            className="materials-grid-2-4" 
                            style={{ backgroundColor: 'orange', height: '0.25rem' }}>
                            &nbsp;
                        </div>
                        
                        {/* <!-- row 3 --> */}
                        <div className="materials-grid-3-1">McMaster-Carr</div>
                        <div className="materials-grid-3-2">Aluminum Sheet</div>
                        <div className="materials-grid-3-3">21 June 2022</div>
                        <div className="materials-grid-3-4">$N,NNN.NN</div>

                        {/* <!-- row 4 --> */}
                        <div className="materials-grid-4-1">McMaster-Carr</div>
                        <div className="materials-grid-4-2">Steel Rod</div>
                        <div className="materials-grid-4-3">21 June 2022</div>
                        <div className="materials-grid-4-4">$N,NNN.NN</div>

                        {/* <!-- row 5 --> */}
                        <div className="materials-grid-5-1">McMaster-Carr</div>
                        <div className="materials-grid-5-2">Flux</div>
                        <div className="materials-grid-5-3">21 June 2022</div>
                        <div className="materials-grid-5-4">$N,NNN.NN</div>

                        {/* <!-- row 6 --> */}
                        <div className="materials-grid-6-1">McMaster-Carr</div>
                        <div className="materials-grid-6-2">Copper Wire</div>
                        <div className="materials-grid-6-3">21 June 2022</div>
                        <div className="materials-grid-6-4">$N,NNN.NN</div>

                    </div>

                </div>

            </div>


            <div className="detail-page-pagination"></div>

        </div>
    );
}

export default MaterialsDetails;
